// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1wrVW","choiceBoxes":"toolbarselects_choiceBoxes__3fugU","simpleField":"toolbarselects_simpleField__21Czw"};